import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\Administrator\\Documents\\GitHub\\pione-group-v2\\src\\components\\pages\\home\\index.tsx");
